// import MfSelfService from 'ui/mfs/MfSelfService2';

const TipsAndTraining = () => <div></div>;
{
  /* <MfSelfService document="dicas_e_treinamentos" />; */
}

export default TipsAndTraining;
